var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-empty',{attrs:{"image":require('@/assets/images/Empty.svg'),"image-style":{
    height: '41px',
  }}},[_c('span',{attrs:{"slot":"description"},slot:"description"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }